import { render, staticRenderFns } from "./IndexEvents.vue?vue&type=template&id=42922adb&scoped=true&"
import script from "./IndexEvents.vue?vue&type=script&lang=js&"
export * from "./IndexEvents.vue?vue&type=script&lang=js&"
import style0 from "./IndexEvents.vue?vue&type=style&index=0&id=42922adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42922adb",
  null
  
)

export default component.exports